
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/eleccions-parlament-catalunya-2021/entrevistes-matins",
      function () {
        return require("private-next-pages/3catinfo/eleccions-parlament-catalunya-2021/entrevistes-matins/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/eleccions-parlament-catalunya-2021/entrevistes-matins"])
      });
    }
  